export class User {
  constructor() {
    this.id = ''
    this.email = ''
    this.firstName = ''
    this.lastName = ''
    this.password = ''
    this.phoneNumber = ''
    this.profilePicture = ''
    this.metadata = {}
    this.createdAt = null
    this.updatedAt = null
  }

  setId(id) {
    this.id = id
    return this
  }

  getId() {
    return this.id
  }

  setEmail(email) {
    this.email = email
    return this
  }

  getEmail() {
    return this.email
  }

  setPhoneNumber(phoneNumber) {
    this.phoneNumber = phoneNumber
    return this
  }

  getPhoneNumber() {
    return this.phoneNumber
  }

  setProfilePicture(profilePicture) {
    this.profilePicture = profilePicture
    return this
  }

  getProfilePicture() {
    return this.profilePicture
  }

  setFirstName(firstName) {
    this.firstName = firstName
    return this
  }

  getFirstName() {
    return this.firstName
  }

  setLastName(lastName) {
    this.lastName = lastName
    return this
  }

  getLastName() {
    return this.lastName
  }

  setPassword(password) {
    this.password = password
    return this
  }

  getPassword() {
    return this.password
  }

  setMetadata(metadata) {
    this.metadata = metadata
    return this
  }

  getMetadata() {
    return this.metadata
  }

  setCreatedAt(date) {
    this.createdAt = date
    return this
  }

  getCreatedAt() {
    return this.createdAt
  }

  setUpdatedAt(date) {
    this.updatedAt = date
    return this
  }

  getUpdatedAt() {
    return this.updatedAt
  }

  // --------- Bulk Setter ---------
  setData(data = {}) {
    Object.entries(data).forEach(([key, value]) => {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    })
    return this
  }
}
